import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';

var Config = require('../../../config');

class ModalFileType extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleCheck = this.handleCheck.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.onCheck = this.onCheck.bind(this);
		
		this.state = {
		    show: false,
		    serology:false,
		    confirm:false,
		    patients:false
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false, serology:false, confirm:false});
	}

	handleShow() {
		if(this.props.location.pathname.indexOf('sample_results') !== -1 || 
			this.props.location.pathname.indexOf('sample_patient_search') !== -1){
			this.setState({patients:true});
		}
		var sections = [];
		this.props.sections.map((s)=>{
			sections.push({
				id:s.section.id,
				name:s.section.name,
				checked:false
			});
		});

		this.setState({show: true, sections:sections});
	}

	handleCheck(e){
		if(e.target.name === 'serology' && e.target.checked){
			var sections = this.state.sections;
			sections.map((s)=>{
				s.checked = false;
			});
			this.setState({confirm:false, sections: sections});
		}

		if(e.target.name === 'confirm' && e.target.checked){
			this.setState({serology:false});
		}

		this.setState({[e.target.name]: e.target.checked ? true : false});
	}

	onPrint(e){
		var file = '';
		var ids = [];

		if(this.state.serology){
			file = this.state.patients ? 'lab_results_patients' : 'area_laboratory';

			this.props.print(e, file);
			
		}

		if(this.state.confirm){
			file = this.state.patients ? 'lab_results_patients_confirm' : 'results_donation_confirm';
			this.state.sections.map((s)=>{
				if(s.checked){
					ids.push(s.id);
				}
			});

			if(ids.length > 0){
				this.props.print(e, file, ids);
			}else{
				swal('Error', 'Debe seleccionar por lo menos una sección', 'error');
			}
		}

		
		this.handleClose();
	}

	onCheck(e, i){
		var section = this.state.sections;

		section[i].checked = e.target.checked ? true : false;

		this.setState({sections:section});
	}

	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Formato de impresión</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<Table responsive hover>
		        				<thead>
		        					<tr>
		        						<th></th>
		        						<th>Formato</th>
		        					</tr>
		        				</thead>
		        				<tbody>
		        					<tr>
		        						<td>
		        							<input type="checkbox" name="serology" id="serology" value={this.state.serology}
		        								checked={this.state.serology} onChange={this.handleCheck} />
		        						</td>
		        						<td>Serología</td>
		        					</tr>
		        					<tr>
		        						<td>
		        							<input type="checkbox" name="confirm" id="confirm" value={this.state.confirm}
		        								checked={this.state.confirm} onChange={this.handleCheck} />
		        						</td>
		        						<td>Confirmatoria</td>
		        					</tr>
		        				</tbody>
		        			</Table>
		        		</div>
		        		{this.state.confirm && 
		        			<div className="col-xs-12">
		        				<Table responsive hover>
			        				<thead>
			        					<tr>
			        						<th></th>
			        						<th>Secciones</th>
			        					</tr>
			        				</thead>
			        				<tbody>
			        					{this.state.sections.map((s, i)=>(
			        						<tr key={i}>
				        						<td>
				        							<input type="checkbox" value={s.checked}
				        								checked={s.checked} onChange={(e)=>this.onCheck(e, i)} />
				        						</td>
				        						<td>{s.name}</td>
				        					</tr>
			        					))}
				        					
			        				</tbody>
			        			</Table>
		        			</div>
		        		}

		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.print')} onClick={this.onPrint}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalFileType);